import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
/* Глобальные клиент, которые шарится по wmf и во всех приложениях один и тот же */
export const queryClient = new QueryClient();
/**
 * Глобальные провайдер, который обарачивает единожды все приложения в host-ui
 * А для локальной разработки обарачивает приложение на localhost
 */
export const ReactQueryProvider = ({ children }) => (_jsx(QueryClientProvider, { client: queryClient, children: children }));
